import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField } from "components/support";
import Moment from "moment";

export default class CustomerCustomInfo extends Component {
  handleValue(value, type) {
    if (type === "date") {
      if (value) {
        return (value = Moment(value, "YYYY/MM/DD").format("DD/MM/YYYY"));
      }
      return;
    } else if (type === "hour") {
      if (value) {
        return (value = Moment(value, "YYYY/MM/DD hh:mm").format("HH:mm"));
      }
      return;
    } else if (type === "datetime") {
      if (value) {
        return (value = Moment(value, "YYYY/MM/DD hh:mm").format(
          "DD/MM/YYYY HH:mm"
        ));
      }
      return;
    } else if (type === "large_text") {
      if (value) {
        return value.replace(/[_-]/g, "");
      }
      return;
    } else if (type === "simple_text") {
      if (value) {
        return value.replace(/[_-]/g, "");
      }
      return;
    } else {
      if (value) {
        return value;
      }
      return;
    }
  }

  handleMask(type) {
    if (type === "phone") {
      return [
        "(",
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ];
    }
    return;
  }

  render() {
    const { customer, configCustomFields } = this.props;
    const custom_fields = customer.custom_fields || {};

    return (
      <div className="grid-container">
        <Row>
          {configCustomFields.map((field, i) => (
            <Col xs={6} key={field.uuid}>
              <DescriptionField
                label={field.name}
                value={this.handleValue(custom_fields[field.uuid], field.type)}
                mask={this.handleMask(field.type)}
              />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/custom-info/index.jsx